// FloorCopyModal.jsx — Kopírovať poschodie: Nové poschodie ALEBO Nahradiť existujúce.
// Mirko 2026-06-04: REPLACE — vyber objekt+poschodie, počet bytov musí sedieť, čísla cieľa zostanú,
// výmera sa prepíše po pozícii (zoradené podľa čísla bytu), parťák sa kopíruje zo zdroja. Potvrdenie NAHRADIT.
import React, { useState } from 'react'

const num = x => { const v = parseFloat(String(x).replace(',', '.')); return isFinite(v) ? v : 0 }
const f = x => (Math.round((x || 0) * 100) / 100).toFixed(2).replace('.', ',')
const calcRoom = (rm, vyska, hlbka) => {
  const bm = (rm.vals || []).reduce((a, x) => a + num(x), 0)
  const hl = (hlbka || 150) / 1000; let dv = 0, ok = 0, spa = 0
  ;(rm.otvory || []).forEach(o => {
    const sM = num(o.s) / 100, vM = num(o.v) / 100, ks = num(o.ks) || 1
    const plo = sM * vM * ks; if (o.typ === 'okno') ok += plo; else dv += plo
    let sp = 0; if (o.L) sp += vM * hl; if (o.P) sp += vM * hl; if (o.H) sp += sM * hl; if (o.D) sp += sM * hl; spa += sp * ks
  })
  const strop = num(rm.strop), ne = num(rm.ne)
  const steny = Math.max(0, bm * num(vyska) - dv - ok + spa - ne)
  return { strop, steny, spolu: steny + strop }
}
const bSum = b => { let t = { strop: 0, steny: 0, spolu: 0 }; (b.rooms || []).forEach(rm => { const c = calcRoom(rm, b.vyska, b.hlbka); t.strop += c.strop; t.steny += c.steny; t.spolu += c.spolu }); return t }
const serializeRooms = rooms => (rooms || []).map(rm => ({
  n: rm.n, partak: rm.partak || '', vals: (rm.vals || []).map(num).filter(x => x > 0),
  strop: num(rm.strop), ne: num(rm.ne),
  otvory: (rm.otvory || []).map(o => ({ typ: o.typ, s: num(o.s) / 100, v: num(o.v) / 100, ks: num(o.ks) || 1, L: !!o.L, P: !!o.P, H: !!o.H, D: !!o.D }))
}))
const newUid = () => 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)
const byBytAsc = (a, b) => String(a.byt || '').localeCompare(String(b.byt || ''), 'sk', { numeric: true })

export default function FloorCopyModal({ o, pk, srcs, allByty, projectId, onClose, onDone }) {
  const sources = [...(srcs || [])].sort(byBytAsc)
  const [mode, setMode] = useState('new')           // 'new' | 'replace'
  const [np, setNp] = useState('')
  const [pref, setPref] = useState('')
  const [tObj, setTObj] = useState('')
  const [tFloor, setTFloor] = useState('')
  const [confirmTxt, setConfirmTxt] = useState('')
  const [busy, setBusy] = useState(false)
  const token = () => localStorage.getItem('kamir_token') || ''
  const H = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` })

  const objekty = [...new Set((allByty || []).map(b => b.obj || '').filter(Boolean))]
  const floorsOf = (obj) => [...new Set((allByty || []).filter(b => (b.obj || '') === obj).map(b => b.po || '').filter(Boolean))]
  const targetByty = (tObj && tFloor) ? [...(allByty || []).filter(b => (b.obj || '') === tObj && (b.po || '') === tFloor)].sort(byBytAsc) : []
  const countMatch = targetByty.length === sources.length
  const lockedTargets = targetByty.filter(b => b.completed_at)

  // ── NOVÉ poschodie ──
  const namesNew = sources.map((b, i) => (pref ? (pref + String(i + 1).padStart(2, '0')) : (b.byt || '?')))
  const collide = np && (allByty || []).some(b => (b.obj || '') === o && (b.po || '') === np)
  const readyNew = !!np.trim() && !collide && !busy

  const runNew = async () => {
    if (!readyNew) return
    setBusy(true)
    try {
      for (let i = 0; i < sources.length; i++) {
        const cl = sources[i]; const t = bSum(cl)
        const body = {
          client_uid: newUid(), project_id: projectId, zakazka: cl.zak, partak: '',   // parťák sa NEkopíruje (každý byt môže robiť niekto iný)
          obj: cl.obj, po: np.trim(), byt: namesNew[i], typ: cl.typ || 'byt',
          vyska: num(cl.vyska), hlbka: cl.hlbka, rooms: serializeRooms(cl.rooms),
          spolu: t.spolu, strop: t.strop, steny: t.steny
        }
        const r = await fetch('/api/vymery', { method: 'POST', headers: H(), body: JSON.stringify(body) })
        if (!r.ok) throw new Error('POST ' + r.status + ' (byt ' + namesNew[i] + ')')
      }
      setBusy(false); if (onDone) await onDone(); onClose()
    } catch (e) { setBusy(false); alert('Prerušené: ' + e.message + '\nČo sa stihlo, je uložené — reload a skontroluj.') }
  }

  // ── NAHRADIŤ existujúce poschodie ──
  const readyReplace = tObj && tFloor && countMatch && lockedTargets.length === 0 && confirmTxt.trim().toUpperCase() === 'NAHRADIT' && !busy
  const runReplace = async () => {
    if (!readyReplace) return
    setBusy(true)
    try {
      for (let i = 0; i < sources.length; i++) {
        const src = sources[i], tgt = targetByty[i]; const t = bSum(src)
        const body = {
          client_uid: tgt.client_uid || newUid(), project_id: projectId, zakazka: tgt.zak,
          partak: tgt.partak || '',                 // parťák CIEĽA ostáva (NEkopíruje sa zo zdroja)
          obj: tgt.obj, po: tgt.po, byt: tgt.byt, typ: tgt.typ || 'byt',   // identita cieľa OSTÁVA
          vyska: num(src.vyska), hlbka: src.hlbka, rooms: serializeRooms(src.rooms),
          spolu: t.spolu, strop: t.strop, steny: t.steny
        }
        const r = await fetch('/api/vymery/' + tgt.id, { method: 'PUT', headers: H(), body: JSON.stringify(body) })
        if (!r.ok) throw new Error('PUT ' + r.status + ' (byt ' + tgt.byt + ')')
      }
      setBusy(false); if (onDone) await onDone(); onClose()
    } catch (e) { setBusy(false); alert('Prerušené: ' + e.message) }
  }

  // ── štýly ──
  const ov = { position: 'fixed', inset: 0, background: 'rgba(20,28,42,.4)', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: '40px 14px', zIndex: 1000 }
  const mod = { width: 560, maxWidth: '100%', background: '#fff', borderRadius: 14, boxShadow: '0 18px 50px rgba(0,0,0,.3)', overflow: 'hidden', fontFamily: 'inherit' }
  const head = { padding: '14px 18px', background: mode === 'replace' ? '#15171A' : '#0284c7', color: '#fff', fontWeight: 800, fontSize: 15 }
  const body = { padding: 18, maxHeight: '76vh', overflow: 'auto' }
  const lab = { fontSize: 11, fontWeight: 800, letterSpacing: '.04em', textTransform: 'uppercase', color: '#5b6573', margin: '6px 0 8px' }
  const inp = { padding: '7px 9px', border: '1px solid #d6dde6', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }
  const panel = { border: '1px dashed #d6dde6', borderRadius: 10, padding: 13, marginBottom: 14, background: '#fafbfd' }
  const ghost = { padding: '9px 16px', border: '1px solid #d6dde6', borderRadius: 8, background: '#fff', color: '#5b6573', fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' }
  const cin = { width: '100%', padding: 10, border: '2px solid #dc2626', borderRadius: 8, fontSize: 15, fontWeight: 800, letterSpacing: '.18em', textAlign: 'center', textTransform: 'uppercase', fontFamily: 'inherit', marginTop: 6, boxSizing: 'border-box' }
  const tab = on => ({ flex: 1, padding: '9px', border: '2px solid ' + (on ? '#15171A' : '#d6dde6'), background: on ? '#FBFAF7' : '#fff', color: on ? '#b45309' : '#5b6573', fontWeight: 800, fontSize: 12, cursor: 'pointer', fontFamily: 'inherit', borderRadius: 9 })

  return (
    <div style={ov} onClick={onClose}><div style={mod} onClick={e => e.stopPropagation()}>
      <div style={head}>Kopírovať poschodie</div>
      <div style={body}>
        <div style={{ background: 'rgba(2,132,199,.1)', border: '1px solid rgba(2,132,199,.3)', borderRadius: 10, padding: '11px 14px', marginBottom: 14 }}>
          <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', color: '#0369a1' }}>Zdroj — poschodie</div>
          <div style={{ fontSize: 15, fontWeight: 800, marginTop: 2 }}>Objekt {o} · Poschodie {pk}</div>
          <div style={{ fontSize: 13, color: '#5b6573', marginTop: 3 }}><b>{sources.length} bytov</b> (miestnosti, otvory, výmery — bez parťáka)</div>
        </div>

        <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
          <div style={tab(mode === 'new')} onClick={() => setMode('new')}>Nové poschodie</div>
          <div style={tab(mode === 'replace')} onClick={() => setMode('replace')}>Nahradiť existujúce</div>
        </div>

        {mode === 'new' ? <>
          <div style={lab}>Cieľ — nové poschodie</div>
          <div style={panel}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573', minWidth: 96 }}>Názov poschodia</label>
              <input value={np} onChange={e => setNp(e.target.value)} placeholder="napr. 2.NP" style={{ ...inp, minWidth: 140 }} />
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573', minWidth: 96 }}>Predpona bytu</label>
              <input value={pref} onChange={e => setPref(e.target.value)} placeholder="napr. 2." style={{ ...inp, width: 110 }} />
              <span style={{ fontSize: 11, color: '#5b6573' }}>prázdne = pôvodné čísla</span>
            </div>
            {collide && <div style={{ marginTop: 8, fontSize: 12, fontWeight: 700, color: '#dc2626' }}>Poschodie „{np}" v objekte {o} už existuje.</div>}
          </div>
          <div style={{ border: '1px solid #d6dde6', borderRadius: 10, padding: '11px 13px', background: '#fafbfd', fontSize: 13 }}>
            Vytvorí <b>{sources.length} nových bytov</b> na <b>{np || '…'}</b>: {namesNew.slice(0, 8).join(', ')}{namesNew.length > 8 ? '…' : ''}.<br />
            <span style={{ color: '#41694C', fontWeight: 700 }}>Existujúce sa NEDOTKNÚ — len pridanie.</span>
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
            <button onClick={onClose} style={ghost}>Zrušiť</button>
            <button disabled={!readyNew} onClick={runNew} style={{ padding: '9px 16px', border: 'none', borderRadius: 8, background: '#0284c7', color: '#fff', fontWeight: 800, fontSize: 13, fontFamily: 'inherit', cursor: readyNew ? 'pointer' : 'default', opacity: readyNew ? 1 : .45 }}>{busy ? 'Vytváram…' : 'Vytvoriť ' + sources.length + ' bytov'}</button>
          </div>
        </> : <>
          <div style={lab}>① Cieľ — ktoré poschodie nahradiť</div>
          <div style={panel}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573' }}>Objekt</label>
              <select value={tObj} onChange={e => { setTObj(e.target.value); setTFloor('') }} style={inp}><option value="">— vyber —</option>{objekty.map(x => <option key={x} value={x}>{x}</option>)}</select>
              <label style={{ fontSize: 12, fontWeight: 700, color: '#5b6573' }}>Poschodie</label>
              <select value={tFloor} onChange={e => setTFloor(e.target.value)} style={inp} disabled={!tObj}><option value="">— vyber —</option>{floorsOf(tObj).map(x => <option key={x} value={x}>{x}</option>)}</select>
            </div>
          </div>
          {tObj && tFloor && <>
            {!countMatch && <div style={{ border: '2px solid #dc2626', background: '#fff5f5', borderRadius: 10, padding: 12, fontSize: 13, marginBottom: 14 }}>
              <b style={{ color: '#dc2626' }}>Počet bytov nesedí</b> — zdroj má <b>{sources.length}</b>, cieľ <b>{targetByty.length}</b>. Nahradenie poschodia vyžaduje rovnaký počet. <b>Kopíruj jednotlivé byty</b> cez „Kopírovať byt → do bytu".
            </div>}
            {countMatch && lockedTargets.length > 0 && <div style={{ border: '2px solid #b45309', background: '#fff7e6', borderRadius: 10, padding: 12, fontSize: 13, marginBottom: 14, color: '#b45309', fontWeight: 700 }}>
              {lockedTargets.length} cieľových bytov je uzamknutých — odomkni ich (Admin PIN) pred nahradením.
            </div>}
            {countMatch && lockedTargets.length === 0 && <>
              <div style={lab}>② Náhľad — čo sa prepíše (čísla bytov ostávajú)</div>
              <div style={{ border: '1px solid #d6dde6', borderRadius: 10, overflow: 'hidden', marginBottom: 14 }}>
                {sources.map((src, i) => <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '6px 11px', borderTop: i ? '1px solid #eef2f7' : 'none', fontSize: 12 }}>
                  <span style={{ color: '#0369a1', minWidth: 90 }}>{tObj}·{tFloor}·<b>{targetByty[i].byt}</b></span>
                  <span style={{ color: '#94a3b8' }}>← výmera z {o}·{pk}·{src.byt}</span>
                  <span style={{ marginLeft: 'auto', color: '#41694C', fontWeight: 700 }}>{f(bSum(src).spolu)} m²</span>
                </div>)}
              </div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#dc2626' }}>Napíš <b>NAHRADIT</b> (prepíše výmery {sources.length} bytov; čísla aj parťák cieľa ostávajú):</div>
              <input value={confirmTxt} onChange={e => setConfirmTxt(e.target.value)} placeholder="NAHRADIT" style={cin} />
            </>}
          </>}
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 16 }}>
            <button onClick={onClose} style={ghost}>Zrušiť</button>
            <button disabled={!readyReplace} onClick={runReplace} style={{ padding: '9px 16px', border: 'none', borderRadius: 8, background: '#dc2626', color: '#fff', fontWeight: 800, fontSize: 13, fontFamily: 'inherit', cursor: readyReplace ? 'pointer' : 'default', opacity: readyReplace ? 1 : .45 }}>{busy ? 'Nahrádzam…' : 'NAHRADIŤ poschodie'}</button>
          </div>
        </>}
      </div>
    </div></div>
  )
}
